import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-therapist-mgt',
  templateUrl: './therapist-mgt.component.html',
  styleUrls: ['./therapist-mgt.component.css']
})
export class TherapistMgtComponent implements OnInit {

  searchForm: FormGroup | any;
  therapistList: any = [];
  total: any;
  currentPage: any = 1;
  itemPerPage = 10;
  therapyStatus: any;
  userId: any;
  therapistFullName: string | any;
  weekDaysofTherapist: any = [];
  selectedDay: any;
  timeZone: any;
  fName: any;
  lName: any;
  slotId: any;
  slotblockedId: any;
  slotStatus: string | any;
  maxDate: Date | any;

  constructor(public service: MainService) {
  }

  ngOnInit() {
    this.searchForm = new FormGroup({
      'search': new FormControl(''),
      'disease': new FormControl(''),
      'status': new FormControl(''),
      'fromDate': new FormControl(''),
      'toDate': new FormControl('')
    });
    this.service.BlockFuture();
    const currentYear = new Date()
    this.maxDate = new Date(currentYear);
    this.getTherapistList(this.currentPage);
  }

  // To get therapist api integration 

  getTherapistList(page: any) {
    this.currentPage = page;
    if (this.searchForm.value.fromDate && this.searchForm.value.toDate) {
      if (this.searchForm.value.fromDate > this.searchForm.value.toDate) {
        this.service.errorToast('Start time should be less than end time');
        return

      }
    }

    let date = new Date(this.searchForm.value.fromDate);
    let year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let date1 = new Date(this.searchForm.value.toDate);
    let year1 = date1.getFullYear();
    let month1: any = date1.getMonth() + 1;
    let dt1: any = date1.getDate();

    if (dt1 < 10) {
      dt1 = '0' + dt1;
    }
    if (month1 < 10) {
      month1 = '0' + month1;
    }

    const data = {
      "search": this.searchForm.value.search,
      // "pageNumber" : this.currentPage,
      "fromDate": this.searchForm.value.fromDate,
      "toDate": this.searchForm.value.toDate,
    }

    if (this.searchForm.value.fromDate) {
      data['fromDate'] = year + '-' + month + '-' + dt
    }
    if (this.searchForm.value.toDate) {
      data['toDate'] = year1 + '-' + month1 + '-' + dt1
    }

    this.service.showSpinner();
    this.service.postApi(ApiUrls.therapistList + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.therapistList = res.result;
        this.total = res.paginationData.total;
        this.itemPerPage = res.paginationData.limit
        this.currentPage = res.paginationData.page
      }
    })
  }


  openActiveBlock(status: any, id: any) {
    this.therapyStatus = status;
    this.userId = id;
    $('#actBlockStatus').modal('show')
  }

  updateActiveBlock() {
    this.therapyStatus == 'ACTIVE' ? this.therapyStatus = 'BLOCK' : this.therapyStatus = 'ACTIVE';
    const data = {
      userId: this.userId,
      status: this.therapyStatus
    }
    this.service.postApi(ApiUrls.actionPerform_therapist, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        $('#actBlockStatus').modal('hide')
        this.service.successToast(res.responseMessage)
        this.getTherapistList(this.currentPage);
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })

  }

  // get slot for therapist api integration 

  getSlotofTherapistApi(id: any, timeZone: any, firstName: any, lastName: any) {

    this.slotId = id;
    this.timeZone = timeZone;
    this.fName = firstName;
    this.lName = lastName;
    this.therapistFullName = firstName + ' ' + lastName
    this.service.showSpinner();
    this.service.getApi(ApiUrls.getSlotFor_booking + `?userId=${id}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {

        this.weekDaysofTherapist = res.result ? res.result : [];
        this.service.hideSpinner();
        if (this.weekDaysofTherapist.length == 0) {
          this.service.errorToast('There are not any available slots')
          return
        }
        else {
          $('#therapistCalender').modal('show')
          this.weekDaysofTherapist = res.result ? res.result : [];
          this.weekDaysofTherapist.sort(function (a: any, b: any) {
            let date1: any = new Date(a.scheduleDate);
            let date2: any = new Date(b.scheduleDate);
            return date1 - date2
          })
        }
      }
      else {
        this.weekDaysofTherapist = res.result ? res.result : [];

        this.service.hideSpinner();


      }
    })
  }

  openBlockSlotModal(id: any, status: any) {
    this.slotblockedId = id;
    this.slotStatus = status;
    if (this.slotStatus == 'BOOKED') {
      return
    } else {
      $('#actBlockSlot').modal('show');
    }

  }


  blockSlotApi() {
    // this.slotStatus == 'AVAILABLE'? this.slotStatus = 'INACTIVE' : this.slotStatus = 'AVAILABLE';
    const data = {
      slotId: this.slotblockedId
    }
    let url;
    if (this.slotStatus == 'AVAILABLE') {
      url = ApiUrls.blockSlot;
    }
    else {
      url = ApiUrls.unblockSlot;
    }
    this.service.showSpinner();
    this.service.postApi(url, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.service.hideSpinner();
        $('#actBlockSlot').modal('hide');
        this.service.successToast(res.responseMessage);
        this.getSlotofTherapistApi(this.slotId, this.timeZone, this.fName, this.lName)
      }
      else {
        this.service.hideSpinner();


      }
    })
  }

  deleteTherapist() {
    const data = {
      userId: this.userId,
      status: 'DELETE'
    }
    this.service.postApi(ApiUrls.actionPerform_therapist, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        $('#deleteUser').modal('hide')
        this.service.successToast(res.responseMessage)
        this.getTherapistList(this.currentPage);
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  dateChange(id: any) {
    this.selectedDay = id;
  }

  Reset() {
    this.searchForm.reset();
    this.getTherapistList(this.currentPage);

  }

  deleteUserModal(id: any) {
    this.userId = id;
    $('#deleteUser').modal('show')
  }

  openCalender() {
    $('#therapistCalender').modal('show')
  }
}
